import { FC, ReactNode, useLayoutEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { Box, Stack, useMediaQuery } from '@mui/material'
import { PHeader } from '../../components/Profile/PHeader'
import { PagesBox, pagesBoxPwaSx, StyledBox, StyledContainer } from './style'
import { Sidebar } from '../../components/Profile/Sidebar'
import { PureLightTheme } from '../../styles/theme'
import { MobileBottomNav } from '../../components/Profile/BottomNavigation'
import { AppContainer } from '../../components/ui-kit/AppContainer'
import { useIsPwa } from '../../hooks/useIsPwa'
import { AuthenticatedNotificationsBootstrap } from '../../components/Notifications/AuthenticatedNotificationsBootstrap'
import { useGetProfileQuery } from '../../api/profile'
import { AuthBootstrapSpinner } from '../../routes/AuthBootstrapSpinner'
import { AccountRecoveryPage } from '../../pages/Profile/AccountRecoveryPage'
import { routesGuest } from '../../consts'

interface ProfileLayoutProps {
  children?: ReactNode
}

const ProfileLayout: FC<ProfileLayoutProps> = ({ children }) => {
  const isMobile = useMediaQuery(PureLightTheme.breakpoints.down('md'))
  const isPwa = useIsPwa()
  const isPwaMobile = isMobile && isPwa
  const { pathname } = useLocation()
  const {
    data: profile,
    isLoading,
    isFetching,
    isUninitialized,
    isError,
  } = useGetProfileQuery()

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  const profilePending = isUninitialized || isLoading || (isFetching && !profile)
  if (profilePending) {
    return <AuthBootstrapSpinner />
  }

  if (isError || !profile) {
    return <Navigate to={routesGuest.ROOT.path} replace />
  }

  if (profile.deleted) {
    return <AccountRecoveryPage />
  }

  return (
    <AuthenticatedNotificationsBootstrap>
      <Box sx={StyledBox}>
        <PHeader />

        <Stack direction='row'>
          {!isMobile && <Sidebar />}
          <Box sx={[PagesBox, isPwaMobile && pagesBoxPwaSx]}>
            <AppContainer sx={StyledContainer}>
              {children || <Outlet />}
            </AppContainer>
          </Box>
        </Stack>

        {isMobile && (
          <MobileBottomNav isPwa={isPwaMobile} />
        )}
      </Box>
    </AuthenticatedNotificationsBootstrap>
  )
}

export default ProfileLayout
